<template>
  <div class="system-page" id="app"  style="overflow-y: scroll;">
    <mt-header :title="'加班/调休详情'">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div class="header" style="display: flex; align-items: center; padding: 0 0; background-color: #f5f5f5;position: sticky; top: 0">
      <div class="scrollable-content" id="scrollableContent" style="height: auto; overflow-y: auto;">
        <div style="width: 22rem;">
          <table class="bo table ">
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">提单人员</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.userName}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">提单部门</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.deptName}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">提单日期</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.applyTime}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">流程状态</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.statusName}}</div></td>
            </tr>
            <tr class="top ss">
              <td colspan="14" class="wi "><div class="bottom" ><label style="margin-top: 10px;font-size:30px;height: 20px;color: #6d9eeb">申请明细</label></div></td>
            </tr>
            <tr v-if="item.startTime">
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">加班开始时间</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.startTime}}</div></td>
            </tr>
            <tr v-if="item.startTime">
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">加班结束时间</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.endTime}}</div></td>
            </tr>
            <tr v-if="item.startTime">
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">加班时长</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.procseeDays}}小时</div></td>
            </tr>
            <tr v-if="item.restOverStartTime">
              <td class="wi" style="width: 100px;" ><label style="width: 180px;margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">调休开始时间(加班)</label></td>
            </tr>
            <tr v-if="item.restOverStartTime">
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.restOverStartTime}}</div></td>
            </tr>
            <tr v-if="item.restOverStartTime">
              <td class="wi" style="width: 200px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">调休结束时间(加班)</label></td>
            </tr>
            <tr v-if="item.restOverStartTime">
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.restOverEndTime}}</div></td>
            </tr>
            <tr v-if="item.restOverStartTime">
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">调休开始时间</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.restStartTime}}</div></td>
            </tr>
            <tr v-if="item.restOverStartTime">
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">调休结束时间</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.restEndTime}}</div></td>
            </tr>
            <tr class="rile" >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">加班/调休事由</label></td>
              <td colspan="7" style="width:160px;">
                <div style="width:200px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  {{item.processDescribe}}
                </div></td>
            </tr>
            <tr class="rile">
              <td class="wi"><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">附件</label></td>
              <td colspan="7" style="width:160px;">
                <div v-if="attachments.length!=0"style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <div
                      v-for="(item, idx) in attachments"
                      :key="idx"
                      style="display: flex; align-items: center; margin-bottom: 5px;">
                    <span>{{ item.attachmentName }} <div class="nameusersub" @click.prevent="previewFile(item)">预览</div></span>
                  </div>

                </div>
                <div v-else  style="width:260px;margin-left: -262px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <div   style="display: flex; align-items: center; margin-bottom: 5px;margin-left: -40px">
                    <span>无文件</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="top">
              <td colspan="14" class="wi "><div class="bottom" ><label  style="margin-top: 10px;font-size:30px;height: 20px;color: #6d9eeb">审批意见</label></div></td>
            </tr>
            <tr class="rile" v-if="!isManage">
              <td class="wi" style="width: 200px;" ><label style="margin-top: 10px;font-size:20px;line-height:20px;height: 20px;width: 160px;color: #6d9eeb">部门负责人({{managerName}})意见</label></td>
              <td colspan="7" style="width:360px;">
                <div style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px;">
                  <img v-if="item.managerSignPicture" :src="managerSignPicture" style="max-height: 50px; border: 1px solid #ddd;width:100px">{{item.managerAdvice}}
                </div>
              </td>
            </tr>
            <tr class="rile" v-if="!isManage&&item.managerTime">
              <td colspan="7">
                <div style="width:380px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px;">
                  <div  style="margin-left: 180px">
                    {{item.managerTime}}
                  </div>
                </div>
              </td>
            </tr>
            <tr class="rile" >
              <td class="wi" style="width: 200px;" ><label style="margin-top: 10px;font-size:20px;line-height:20px;height: 20px;width: 160px;color: #6d9eeb">分管领导({{fgldName}})意见</label></td>
              <td colspan="7" style="width:360px;">
                <div style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px;">
                  <img v-if="item.fgldSignPicture" :src="fgldSignPicture" style="max-height: 50px; border: 1px solid #ddd;width:100px">{{item.fgldAdvice}}
                </div>
              </td>
            </tr>
            <tr class="rile" v-if="item.fgldTime">
              <td colspan="7" >
                <div style="width:380px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px;">
                  <div  style="margin-left: 180px">
                    {{item.fgldTime}}
                  </div>
                </div>
              </td>
            </tr>
            <tr class="rile" v-if="!isOffice">
              <td class="wi" style="width: 200px;" ><label style="margin-top: 10px;font-size:20px;line-height:20px;height: 20px;width: 160px;color: #6d9eeb">办公室({{officeName}})意见</label></td>
              <td colspan="7" style="width:360px;">
                <div style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <img v-if="item.officeSignPicture" :src="officeSignPicture" style="max-height: 50px; border: 1px solid #ddd;width:100px">{{item.officeAdvice}}
                </div>
              </td>
            </tr>
            <tr class="rile" v-if="item.officeTime">
              <td colspan="7" >
                <div style="width:380px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px;">
                  <div  style="margin-left: 180px">
                    {{item.officeTime}}
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tabModule from "@/components/footerBar/index.vue";
import { getLocalData } from "@/utils/sessionData.js";
import request from "@/utils/keyCloakRequest";
import { resolveAppIsManage, syncAppReviewerNames } from "@/utils/appProcessManager";
import axios from "axios";
import {Indicator} from "mint-ui";
export default {
  components: {
    "v-tab-module": tabModule,
  },
  beforeMount() {},
  data() {
    return {
      managerSignPicture:'',
      fgldSignPicture:'',
      zyldSignPicture:'',
      officeSignPicture:'',
      officeName:'',
      managerName:'',
      fgldName:'',
      processId:'',
      item:{},
      route:'',
      userInfo: {},
      isLoading: false,
      isOffice: false,
      attachments:[],
      isManage:false,
      roleId:null
    };
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.processId = this.$route.query.item.processId;
    axios({
      url: process.env.VUE_APP_SSO_URL+"appOverDetail?processId="+this.processId,
      method: "get",
    }).then(response => {
      this.item = response.data
      this.item.processId = this.processId
      // if(this.item.managerSignPicture){
      //   request({
      //     url: "image/"+this.item.managerSignPicture,
      //     method: "POST",
      //     responseType: 'blob'
      //   }).then(response => {
      //     const blob = new Blob([response], { type: 'image/jpeg' });
      //     this.managerSignPicture =  URL.createObjectURL(blob);
      //   })
      // }
      // if(this.item.fgldSignPicture){
      //   request({
      //     url: "image/"+this.item.fgldSignPicture,
      //     method: "POST",
      //     responseType: 'blob'
      //   }).then(response => {
      //     const blob = new Blob([response], { type: 'image/jpeg' });
      //     this.fgldSignPicture =  URL.createObjectURL(blob);
      //   })
      // }
      // if(this.item.officeSignPicture){
      //   request({
      //     url: "image/"+this.item.officeSignPicture,
      //     method: "POST",
      //     responseType: 'blob'
      //   }).then(response => {
      //     const blob = new Blob([response], { type: 'image/jpeg' });
      //     this.officeSignPicture =  URL.createObjectURL(blob);
      //   })
      // }
      syncAppReviewerNames(this, this.item)
      resolveAppIsManage(this, this.item, this.item.processId || this.processId)
      request({
        url: "appFindDeptId?userId="+this.item.userId,
        method: "get"
      }).then(  response => {
        if(response==2){
          this.isOffice = true
        }else {
          this.isOffice = false
        }
      })
      if(this.item.proFileid!=""){
        request({
          url: "appDocumentFile?fileIds="+this.item.proFileid,
          method: "get"
        }).then(  response => {
          this.attachments = response
        })
      }
      this.allLoaded = true;
      Indicator.close();
    })
    this.route =  this.$route.query.route
  },
  mounted() {
  },

  methods: {
    previewFile(attachment){
      this.$router.push({
        name: 'filePreview',
        query: {
          attachment: attachment,
          item: this.item,
          route:this.route,
          name:'overTimeListDetail'
        },
      });
    },
    goBack() {
      this.$router.push(this.route);
    },
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 0.6rem;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}

body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.menuTitle {
  font-size: 1rem;
}
.system-page {
  width: 100%;
  height: 100vh;
  background-color: #f1f5f8;
  font-family: "PingFangSC-Regular";
}
/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
.nameusersub{
  width: 40%;
  height: 100px;
  line-height: 100px;
  background: #5cb85c;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #e5f4f9;
}
</style>
